export default "__VITE_ASSET__BZ_wC$sj__"